/**
 * Parses a whole resource file into its property bag. A `.tres` is a `.tscn` without `[node]`
 * sections, with a `[gd_resource]` header and one `[resource]` body. Rides TscnParserCore. Values
 * stay raw strings for consumers such as the TileSet resolver to decode.
 */
import { stringLiteral } from '../godot/string/string.js';
import { TscnParserCore } from './TscnParserCore.js';
/** Throws when the content has no [gd_resource] header (not a .tres file). */
export function parseTresFile(content) {
    const { scene } = new TscnParserCore().parse(content, () => null);
    const { resourceType } = scene;
    if (!resourceType) {
        throw new Error('Invalid .tres file: missing [gd_resource] header type');
    }
    return {
        resourceType,
        properties: scene.mainResource?.data ?? {},
        extResources: scene.externalResources,
        subResources: scene.internalResources,
    };
}
/** A `.gdshader` file as the Shader resource Godot loads from it, its text the code. */
export function parseShaderFile(content) {
    return {
        resourceType: 'Shader',
        properties: { code: stringLiteral(content) },
        extResources: [],
        subResources: [],
    };
}
//# sourceMappingURL=parsedResource.js.map